export { default } from './MagaluAdsShowcase';